/* AboutScreen's website slots (shared-client-screens D3, card 2 rows H2, H5, H6, H10): the welcome on the
 photo (frame C, logo frame D of docs/mockups/telify-web/phone-guest-home.html and phone-guest-logo.html), the
 services and Happening Soon in the sheet (AboutOfferings), and room for the floating bar. Theme tokens only.
 Unlayered: these rules adjust the app's own CSS modules (AboutPage, BookingHubPage, BookSessionPage), which are
 unlayered. */
/* "Welcome to" and the name sit on the photo just above the sheet edge; the sheet does not repeat them. */
.heroText {
  position: absolute;
  z-index: 1;
  left: 20px;
  right: 20px;
  bottom: 50px;
  /* Frame D of phone-guest-logo.html (Gabriel 2026-10-21, "go with D centered logo above the name"): one centered stack. */
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

/* The studio's logo keeps its whole shape in the box, as the app's logo header does, with a shadow that holds it on the photo. */
.logo {
  display: block;
  width: 72px;
  height: 64px;
  margin-bottom: 14px;
  filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.4));
}

.logo img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center bottom;
  border-radius: 12px;
}

/* The studio's Descriptor under the name, in small capitals in the accent color. */
.descriptor {
  margin-top: 8px;
  color: var(--accent);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;
  letter-spacing: 3px;
  text-transform: uppercase;
  text-shadow: 0 1px 10px rgba(0, 0, 0, 0.45);
}

.heroText h1 {
  margin-top: 6px;
  text-shadow: 0 2px 18px rgba(0, 0, 0, 0.35);
}

.heroText div {
  text-shadow: 0 1px 10px rgba(0, 0, 0, 0.4);
}

/* Doubled class: outweighs the app's single-class rule it adjusts (the home's .page margin) whatever order the CSS loads in. */
.inSheet.inSheet {
  margin-top: 28px;
}

/* Happening Soon's heading reads as the sheet's other headings (the About page's section title). Only a section's
 own header: the service cards' titles are h2s too and keep the app's size. */
.inSheet > section > div:first-child > h2 {
  margin: 0;
  font-family: var(--client-font-heading, 'EB Garamond', Georgia, serif);
  font-weight: 600;
  font-size: 22px;
  letter-spacing: -0.012em;
  color: var(--text-primary);
}

.inSheet > section + section {
  margin-top: 26px;
}

.services {
  margin-top: 4px;
  margin-bottom: 30px;
}

.title.title {
  margin-bottom: 0;
}

.list.list {
  padding: 0;
}

/* Room for the floating bar. */
.navSpace {
  height: 120px;
}
